import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';
import { filter, map, Observable } from 'rxjs';
import { LoanOfficerModel } from '../../cmg-1003/models';

import { Cmg1003LoanOfficerStore } from './loan-officer.store';
import { DirtyChecker2 } from '../core/dirty-checker-2';

@Injectable({ providedIn: 'root' })
export class Cmg1003LoanOfficerQuery extends Query<LoanOfficerModel> {
  protected store: Cmg1003LoanOfficerStore;

  dirtyChecker2: DirtyChecker2 = new DirtyChecker2(this.store, this);
  constructor() {
    const store = inject(Cmg1003LoanOfficerStore);

    super(store);

    this.store = store;
  }

  selectLoanOfficerInfo(): Observable<LoanOfficerModel> {
    return this.select().pipe(filter((state) => !!state.retailLeadType));
  }

  selectRetailLeadType(): Observable<string> {
    return this.selectLoanOfficerInfo().pipe(map((state) => state.retailLeadType));
  }
}
